import { render, staticRenderFns } from "./ListPurchase.vue?vue&type=template&id=7d150caa&"
import script from "./ListPurchase.vue?vue&type=script&lang=js&"
export * from "./ListPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d150caa')) {
      api.createRecord('7d150caa', component.options)
    } else {
      api.reload('7d150caa', component.options)
    }
    module.hot.accept("./ListPurchase.vue?vue&type=template&id=7d150caa&", function () {
      api.rerender('7d150caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ListPurchase.vue"
export default component.exports